let config = {
    copyright: '©2025 LiTingqiang',
    email: 'wgrjaw@gmail.com',
    policy: 'https://mhaherolegends.com/privacy_policy.html',
    term: 'https://mhaherolegends.com/terms.html'
}
export default config;